import { render, staticRenderFns } from "./metodosPago.vue?vue&type=template&id=8a1c12e2&scoped=true"
import script from "./metodosPago.vue?vue&type=script&lang=js"
export * from "./metodosPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1c12e2",
  null
  
)

export default component.exports